import { styled } from '@mui/material'

export const LoadingWrapper = styled('div')({
  height: '100vh',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})
